export default "__VITE_ASSET__aN1a9MBf__"